<!-- 博慧轩图书 -->
<template>
  <div class="container">
    <img :src="currentCourse.imgBgUrl" alt="" class="img" />
    <div class="input-container">
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="gs-box"><span>开课科目：</span>{{ currentCourse.subjectDes }}</div>
      <div class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '管理专硕',
          id: 'BK202405290001',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_guanlizhuanshuo_bg.jpg',
          major: '',
          subjectDes: '英语二、管理类综合能力',
          promotedAccount: '博慧轩图书-管理考研',
          subjectList: [
            {
              name: '英语二+管综',
              worthid: 'dc90b91a611b4cde8f73b3a7e4a7c8bf',
              subjectid: '6c1095e7c99c4e5397a57d575a2db3e5'
            }
          ]
        },
        {
          name: '教育专硕',
          id: 'BK202406180004',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_jiaoyuzhuanshuo_bg.jpg',
          major: '',
          subjectDes: '英语一/二、政治、教综',
          promotedAccount: '博慧轩图书-教育考研',
          subjectList: [
            {
              name: '英语一+政治+教育综合',
              worthid: 'b97eafdd85f24d65bb27bf0d9f16b025',
              subjectid: 'b5fee91a139d41a2ae33ceddc4c24e72'
            },
            {
              name: '英语二+政治+教育综合',
              worthid: 'd9222f377ca440d09be9dd03fa5cff69',
              subjectid: '8f6f0bbf333a453889b5a19a0175614b'
            }
          ]
        },
        {
          name: '护理/护理学',
          id: 'BK202406180005',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_huli_hulixue_bg.jpg',
          major: '',
          subjectDes: '英语一、政治、护理综合',
          promotedAccount: '博慧轩图书-护理考研',
          subjectList: [
            {
              name: '英语一+政治+护理综合',
              worthid: '72ec7ea2e9244aa5a00273b0512dad55',
              subjectid: '2b7765fafbcd4879a5efe710f6ebe0bc'
            }
          ]
        },
        {
          name: '临床医学(西医)',
          id: 'BK202406180006',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_linchuangxiyi_bg.jpg',
          major: '',
          subjectDes: '英语一、政治、西医综合',
          promotedAccount: '博慧轩图书-西医考研',
          subjectList: [
            {
              name: '英语（一）',
              worthid: '102b4d6eb3564eb6bfe6f34de203bdb8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '思想政治理论',
              worthid: '12f06d48e165474a8a2ff36c6d742dd4',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            },
            {
              name: '临床医学综合能力(西医)',
              worthid: '354e0d7334684bbe8708d7ff974366b0',
              subjectid: '3f13dafd598947d2800124b3cf6cd796'
            }
          ]
        },
        {
          name: '法律(法学)/法律(非法学)',
          id: 'BK202406180007',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_falv_bg.jpg',
          major: '',
          subjectDes: '英语一、政治、法律综合',
          promotedAccount: '博慧轩图书-法律考研',
          subjectList: [
            {
              name: '英语（一）',
              worthid: 'd715e3b213194851abf2f65973131ca8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '思想政治理论',
              worthid: 'b761d99bc207411b8a541a74f8b81992',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            },
            {
              name: '法律（法学）专业基础+综合',
              worthid: '389607c181d64b2e8eb474a0d6faf3df',
              subjectid: 'f7b205a2ec6542948686b7720e36a6ac'
            },
            {
              name: '法律（非法学）专业基础+综合',
              worthid: '60371610fa634c99817f3a01280af950',
              subjectid: '6a289a14a645473faa9bc443aa0acbc5'
            }
          ]
        },
        {
          name: '应用心理',
          id: 'BK202406180008',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_yingyongxinli_bg.jpg',
          major: '',
          subjectDes: '英语一/二、政治、心理学综合',
          promotedAccount: '博慧轩图书-心理学考研',
          subjectList: [
            {
              name: '英语一+政治+心理学综合',
              worthid: 'd20a18cf965f43e4b36dfc6239dda3a1',
              subjectid: '4eef0d0b666043989e93abc06aed1791'
            },
            {
              name: '英语二+政治+心理学综合',
              worthid: '09bb4151f49e442092c52c13f9c99dd4',
              subjectid: 'c9e4bf34acf84120992c87c73f72f79a'
            }
          ]
        },
        {
          name: '英语',
          id: 'BK202406180009',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_yingyu_bg.jpg',
          major: '',
          subjectDes: '英语一/二',
          promotedAccount: '博慧轩图书-英语考研',
          subjectList: [
            {
              name: '英语（一）',
              worthid: 'e6699f489d214dea93014275a40e1037',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '英语（二）',
              worthid: 'c90b2a33d1cb4d42a6f0cb61dbb3457b',
              subjectid: '318bce61f95740d1aed00a31ea465d23'
            }
          ]
        },
        {
          name: '政治',
          id: 'BK202406180010',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_zhengzhi_bg.jpg',
          major: '',
          subjectDes: '政治',
          promotedAccount: '博慧轩图书-政治考研',
          subjectList: [
            {
              name: '思想政治理论',
              worthid: '1476bcffcba547509ffa69ee646e28fd',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            }
          ]
        },
        {
          name: '数学',
          id: 'BK202406180011',
          imgBgUrl: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/ky_shuxue_bg.jpg',
          major: '',
          subjectDes: '数学一、数学二、数学三',
          promotedAccount: '博慧轩图书-数学考研',
          subjectList: [
            {
              name: '数学（一）',
              worthid: '74bf8b58378a423c971247d89d5b86a3',
              subjectid: '6545d2a56d594562b7db97e65b44b667'
            },
            {
              name: '数学（二）',
              worthid: 'e01e324acd2049dfae2bf48a81a226ec',
              subjectid: '6d485fc3920042eb926718f7f77f5174'
            },
            {
              name: '数学（三）',
              worthid: '52a6cfc4171a439ca526d0d5be45c2c0',
              subjectid: '70e3a9f7a5b34c7bb6d3e587597a683c'
            }
          ]
        }
      ],
      id: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true
    }
  },
  methods: {
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: '研究生招生初试',
        orign: '图书',
        promotedAccount: this.currentCourse.promotedAccount,
        promotednum: this.$route.params.promotednum
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
        setTimeout(() => {
          window.location.href = 'https://www.zhongke3.com/zj-app-h5/mp_toutiao/qscode/1816113967479894016'
        }, 2000)
      })
    }
  },
  created() {
    this.id = this.$route.params.id
    this.currentCourse = this.list.find(item => item.id == this.id)
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 53vw;
    width: 100%;
    padding: 149vw 9.5vw 0;
    z-index: 1;
    .gs-box {
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin-top: 16px;
      span {
        color: rgb(0, 94, 233);
      }
    }
    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      input {
        flex: 1;
        border: none;
        outline: none;
        background: #fff;
        padding-left: 10px;
        border: 1px solid #f1f8ff;
        border-radius: 4px;
        height: 41px;
        box-shadow: none;
        background: #f3f4f6;
        font-size: 12px;
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 106px;
        height: 41px;
        border-radius: 5px;
        background: rgb(56, 114, 235);
        margin-left: 10px;
        color: #fff;
        font-size: 12px;
        span {
          color: #fff;
        }
      }
    }
    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 90%;
      margin: 18px auto 0;

      font-weight: bold;
      margin: 12px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
    }
  }
}
</style>
